import * as React from 'react';
import IWorkingHour from '../calendar/IWorkingHour';
import { Translate } from '../../shared/LanguageService';
import { assign } from '../../shared/Assign';
import { Button, FormGroup, FormControl, ControlLabel, Row, Col, Checkbox } from 'react-bootstrap';
import DateTime from 'react-datetime';
import moment from 'moment';

interface IProps {
    workingHours: any[];
    onChange: (workingHours: any[]) => void;
}

interface IState {}

class WorkingHoursForm extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {};
    }

    getDayName(day: number) {
        let translationKey = 'photographercalendar/workinghours/modal/days';
        switch (day) {
            case 0:
                return Translate(`${translationKey}/sunday`);
            case 1:
                return Translate(`${translationKey}/monday`);
            case 2:
                return Translate(`${translationKey}/tuesday`);
            case 3:
                return Translate(`${translationKey}/wednesday`);
            case 4:
                return Translate(`${translationKey}/thursday`);
            case 5:
                return Translate(`${translationKey}/friday`);
            case 6:
                return Translate(`${translationKey}/saturday`);
            default:
                break;
        }
    }

    workHourDateChange(day: number, time: any, startTime: boolean) {
        let workingHours = assign([], this.props.workingHours);

        if (!moment.isMoment(time)) {
            this.props.onChange(workingHours);
            return;
        }
        let currentWorkingHours = workingHours.find((x) => x.day === day);
        let newTime = time.format();
        if (startTime) {
            currentWorkingHours.start = time;
        } else {
            currentWorkingHours.end = time;
        }

        this.props.onChange(workingHours);
    }

    toggleAvailable(day: number) {
        let workingHours = assign([], this.props.workingHours);
        let currentWorkingHours = workingHours.find((x) => x.day === day);
        currentWorkingHours.isAvailable = !currentWorkingHours.isAvailable;
        this.props.onChange(workingHours);
    }

    reorderDaysBasedOnLocale(): any[] {
        let firstDayOfWeek = moment.localeData().firstDayOfWeek();
        let workingHours = assign([], this.props.workingHours);

        if (workingHours && workingHours.length > 0) {
            while (firstDayOfWeek !== workingHours[0].day) {
                workingHours.push(workingHours.shift());
            }
        }

        return workingHours;
    }

    render() {
        let workingHours = this.reorderDaysBasedOnLocale();

        return (
            <div>
                {workingHours.map((workHours, index) => {
                    let nameOfDay = this.getDayName(workHours.day);
                    return (
                        <FormGroup key={'workinghours-' + index}>
                            <ControlLabel>{nameOfDay}</ControlLabel>
                            <Row>
                                <Col lg={3}>
                                    <DateTime
                                        locale={moment.locale()}
                                        dateFormat={false}
                                        viewMode="time"
                                        value={workHours.start}
                                        onChange={(time: any) =>
                                            this.workHourDateChange(workHours.day, time, true)
                                        }
                                        onFocus={() =>
                                            document
                                                .getElementById(`rdt-wh-start-${nameOfDay}`)
                                                .blur()
                                        }
                                        inputProps={{
                                            id: `rdt-wh-start-${nameOfDay}`,
                                            disabled: !workHours.isAvailable ? 'disabled' : ''
                                        }}
                                    />
                                </Col>
                                <Col lg={3}>
                                    <DateTime
                                        locale={moment.locale()}
                                        dateFormat={false}
                                        viewMode="time"
                                        value={workHours.end}
                                        onChange={(time: any) =>
                                            this.workHourDateChange(workHours.day, time, false)
                                        }
                                        onFocus={() =>
                                            document
                                                .getElementById(`rdt-wh-end-${nameOfDay}`)
                                                .blur()
                                        }
                                        inputProps={{
                                            id: `rdt-wh-end-${nameOfDay}`,
                                            disabled: !workHours.isAvailable ? 'disabled' : ''
                                        }}
                                    />
                                </Col>
                                <Col lg={4}>
                                    <Checkbox
                                        inline
                                        name={`IsAvailable${index}`}
                                        checked={!workHours.isAvailable}
                                        onChange={() => {
                                            this.toggleAvailable(workHours.day);
                                        }}
                                    >
                                        <span>
                                            {Translate(
                                                'photographer/modal/form/calendar/not-available'
                                            )}
                                        </span>
                                    </Checkbox>
                                </Col>
                            </Row>
                        </FormGroup>
                    );
                })}
            </div>
        );
    }
}

export default WorkingHoursForm;
